<template>
  <div>
    <el-divider v-if="id" content-position="left"
      ><span class="dividerTitle">退还详情</span></el-divider
    >
    <el-form
      class="elFormClass"
      :model="formParams"
      ref="ruleForm"
      label-width="auto"
      :disabled="id ? true : false"
      size="small"
    >
      <div class="flex_between_wrap">
        <el-form-item
          style="width:300px;"
          v-for="item in firstItem"
          :key="item.model"
          :label="item.label"
          :prop="item.model"
          :rules="item.rules ? formRules.requiredChange : formRules.not"
        >
          <!-- <x-select
            ref="usePerson"
            @change="usePersonChange"
            :placeholder="
              formParams.deptId ? '请选择' + item.label : '请先选择使用组织'
            "
            style="flex:1;"
            v-if="item.model == 'usePerson'"
            label="staffName"
            model="id"
            :queryNow="false"
            :isopen="true"
            v-model="formParams[item.model]"
            url="/pc/admin/page"
            :params="userparams"
          >

          </x-select> -->

                 <el-input
           style="flex:1;"
            v-if="item.model == 'usePersonName'"
            @focus="usePersonFocus(formParams.deptId)"
            v-model="formParams[item.model]"
            :placeholder="id?'':
              formParams.deptId ? '请选择' + item.label : '请先选择使用组织'
            "
          ></el-input>
          <x-Treeselect
                :defaultExpandLevel="Infinity"

            :disabled="id ? true : false"
            style="flex:1"
            :placeholder="id?'':'请选择' + item.label"
            @select="deptIdselect"
            @input="closedeptId"
            v-else-if="item.model == 'deptId'"
            v-model="formParams[item.model]"
            :clearable="true"
            :multiple="false"
            :options="deptArr"
            value="id"
            label="deptName"
            id="id"
          ></x-Treeselect>

          <el-date-picker
            style="width:100%"
            v-else-if="item.model == 'startTime' || item.model == 'endTime'"
            v-model="formParams[item.model]"
            type="date"
            value-format="yyyy-MM-dd"
            :placeholder="id?'':`选择` + item.label"
            :picker-options="{
              shortcuts: [
                {
                  text: '今天',
                  onClick(picker) {
                    picker.$emit('pick', new Date());
                  },
                },
                {
                  text: '昨天',
                  onClick(picker) {
                    const date = new Date();
                    date.setTime(date.getTime() - 3600 * 1000 * 24);
                    picker.$emit('pick', date);
                  },
                },
                {
                  text: '一周前',
                  onClick(picker) {
                    const date = new Date();
                    date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit('pick', date);
                  },
                },
              ],
            }"
          >
          </el-date-picker>
          <el-input
            type="textarea"
            autosize
            v-else
            v-model="formParams[item.model]"
          ></el-input>
        </el-form-item>
      </div>
    </el-form>

    <el-divider content-position="left" v-if="!id"
      ><span class="dividerTitle">待退还资产{{ ids.length }}</span></el-divider
    >

    <!-- <div class="flex_between_nowrap">
      <el-button type="main">移除资产</el-button>
      <div class="flex_end">
        <el-input
          v-model="tableParams['assetCode']"
          style="margin-right:20px"
          size="small"

          placeholder="请输入条码或扫描条码"
        ></el-input>
        <el-button type="main">添加资产</el-button>
      </div>
    </div> -->

    <x-table ref="xTable" :tableData="changeData" max-height='500'>
      <el-table-column
        :label="item.label"
        show-overflow-tooltip
        :prop="item.model"
        v-for="item in columnArr"
        :key="item.label"
        ><template slot-scope="scope">
          <div style="width:100%" v-if="item.model == 'assetStatus'">
            <el-tag :style="assetStatusFulter(scope.row[item.model], false)">{{
              assetStatusFulter(scope.row[item.model], true)
            }}</el-tag>
          </div>
          <span v-else>{{ scope.row[item.model] }}</span>
        </template></el-table-column
      >
    </x-table>

    <div
      class="flex_between_nowrap "
      style="margin-top:40px"
      v-if="id && callBack"
    >
      <label style="width:100px;text-align:left">审批备注</label>
      <el-input
        v-model="approveRemark"
        clearable
        type="textarea"
        autosize
      ></el-input>
      <div class="flex_between_nowrap" style="margin-left:40px">
        <el-button
          class="dialog_close"
          size="small"
          @click="examine(false, id, approveRemark)"
          >驳 回</el-button
        >
        <el-button
          class="dialog_submit"
          size="small"
          style="width:100px"
          type="submit"
          @click="examine(true, id, approveRemark)"
          >同 意</el-button
        >
      </div>
    </div>
    <div class="dialog_bottom" style="margin-top:20px" v-if="!id">
      <el-button class="dialog_close" size="small" @click="closeDialog"
        >取 消</el-button
      >
      <el-button
        class="dialog_submit"
        size="small"
        style="width:100px"
        type="submit"
        @click="submit"
        >确 定</el-button
      >
    </div>
  </div>
</template>
<script>
export default {
  props: {
    id: String,
newId:String,
    callBack: Function,
    changeData: Array,
    ids: Array,
    defaultRow: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      approveRemark: "",

      columnArr: [
        {
          label: "状态",
          model: "assetStatus",
        },
        {
          label: "资产编码",
          model: "assetCode",
        },
        {
          label: "资产名称",
          model: "assetName",
        },
        {
          label: "资产分类",
          model: "assetClassifyName",
        },

        {
          label: "所属组织",
          model: "deptName",
        },
        {
          label: "使用组织",
          model: "useDeptName",
        },
        {
          label: "管理人员",
          model: "assetAdminName",
        },
        {
          label: "使用人",
          model: "usePersonName",
        },
        {
          label: "所在区域",
          model: "areaName",
        },
        {
          label: "资产来源",
          model: "sourceName",
        },
        {
          label: "存放地点",
          model: "depositArea",
        },
        {
          label: "规格型号",
          model: "spec",
        },
        {
          label: "计量单位",
          model: "unit",
        },
        {
          label: "价值",
          model: "price",
        },
        {
          label: "使用期限",
          model: "liveTime",
        },
        {
          label: "入库日期",
          model: "inTime",
        },
        {
          label: "供应商",
          model: "supplier",
        },
        {
          label: "联系电话",
          model: "supplierPhone",
        },
        {
          label: "备注",
          model: "remark",
        },
      ],
      formParams: { ids: this.ids },
      deptArr: [],
      firstItem: [
        {
          label: "退还日期",
          model: "retTime",
          rules: true,
        },

        {
          label: "退还备注",
          model: "remark",
        },
      ],
    };
  },

  mounted() {},
  methods: {
    usePersonCallBack(data) {
      if (data.id) {
          this.$set(this.formParams,'usePersonName',data.staffName)
        this.$set(this.formParams,'usePerson',data.id)
      }
        
    },
    usePersonFocus(deptId) {
      this.$createDialog(this, {
        dialogConfig: { title: "选择人员", width: "50%" },
        namespace: "select_account",
        whetherDestruction: true,

        assemblyConfig: {
          deptId,
          callBack: this.usePersonCallBack,
        },
      });
    },
    examine(pass, id, remark) {
      this.$requestAxiosForm(
        {
          url: "/pc/examine/examine",
          data: { id, pass, remark },
        },
        (data) => {
          this.$success();
          this.closeDialog();
          this.callBack();
        }
      );
    },
    init() {
      if (this.defaultRow) {
        this.formParams = Object.assign({}, this.defaultRow);
        this.$set(this.formParams, "retTime", this.$getCurrentDate());
      }
    },
    assetStatusFulter(data, flag) {
      let str = "";
      if (flag) {
        switch (data) {
          case "idle":
            str = "闲置";

            break;

          case "use":
            str = "在用";

            break;
          case "borrow":
            str = "借用";

            break;
          case "repair":
            str = "维修中";

            break;
          case "dispose":
            str = "处置";

            break;
          case "examine":
            str = "审批中";

            break;
        }
      } else {
        switch (data) {
          case "use":
            str = "color:#436bff;background:#d8e6ff;";

            break;
          case "borrow":
            str = "color:#436bff;background:#d8e6ff;";

            break;
          case "examine":
            str = "color:#436bff;background:#d8e6ff;";

            break;

          case "idle":
            str = "color:#42b983;background:#f0f9eb;";

            break;
          case "dispose":
            str = "color:#ffa200;background:#ffefd8;";
            break;
          case "repair":
            str = "color:#ffa200;background:#ffefd8;";
            break;
        }
      }
      return str;
    },

    submit() {
      this.$formValidate(this, "ruleForm").then(() => {
        let submit = JSON.parse(JSON.stringify(this.formParams));
        if(this.newId){
          submit.id=this.newId
        }
        this.$requestAxiosForm(
          {
            url: "/pc/operate/receive/ret",

            data: submit,
          },
          (data) => {
            this.$success();
            this.closeDialog();
            this.callBack();
          }
        );
      });
    },
  },
};
</script>
<style scoped>
.dividerTitle {
  font-size: 18px;
  letter-spacing: 0px;
  color: #436bff;
  font-weight: bold;
}
</style>
